/* eslint-disable arrow-body-style */
import { Main } from '@src/app/Main/Main';
import React, { FC, PropsWithChildren } from 'react';

export const FilterPanelMain: FC<PropsWithChildren> = ({ children }) => (
  <Main id="filterPanelPage">
    <div id="filterPanelPageContent">{children}</div>
  </Main>
);
